import { useEffect, useState } from "react";

import Image from "next/image";

import { useGlobalContext } from "shared/utils/hooks/useGlobalContext";

import AuthModal from "../AuthModal";
import { ExclusivePageContainer } from "./styles";

function ExclusivePage() {
  const { state, setState } = useGlobalContext();
  const [showLoginModal, setShowLoginModal] = useState(state?.modal?.open);

  const {
    tenancy: {
      settings: { users, site },
    },
  } = state;

  const isPlatformIsPrivate = site?.privatePlatform === "1";

  const userLoginPersonalization: "unique" | "modal" =
    users?.userLoginPersonalization ?? "modal";

  const isUniquePageLogin = userLoginPersonalization === "unique";

  useEffect(
    function openLoginFormOnUniqueAuthPage() {
      if (isPlatformIsPrivate) setShowLoginModal(true);
    },
    [isPlatformIsPrivate, setState],
  );

  return (
    <ExclusivePageContainer isPlatformIsPrivate={isPlatformIsPrivate}>
      <Image
        className="exclusive-page-background-image"
        alt=""
        src={users?.userSignUpImage}
        fill
        quality={100}
      />
      <AuthModal showLoginModal={showLoginModal || isUniquePageLogin} />
    </ExclusivePageContainer>
  );
}

export default ExclusivePage;
